export const createPropertyTagState = () => ({
    id: null,
    name: '',
    display: '',
    color: '#000000',
    icon: '',
    sortOrder: 0,
});
